/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Seg_EyebrowInputs */

const en_funnel_ob_seg_eyebrow = /** @type {(inputs: Funnel_Ob_Seg_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So we can tailor this`)
};

const es_funnel_ob_seg_eyebrow = /** @type {(inputs: Funnel_Ob_Seg_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para poder adaptarlo a ti`)
};

/**
* | output |
* | --- |
* | "So we can tailor this" |
*
* @param {Funnel_Ob_Seg_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_seg_eyebrow = /** @type {((inputs?: Funnel_Ob_Seg_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Seg_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_seg_eyebrow(inputs)
	return en_funnel_ob_seg_eyebrow(inputs)
});